import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import List from '@material-ui/core/List'
import crypto from 'crypto-js'
import { snakeToCamel } from '../../../helpers/common'
import { getUserInfo, getCognitoAccessToken } from '../../../helpers/auth'
import CustomCard from './Card'
import CustomListItem from './CustomListItem'
import { getGlobalAccountUrl } from '../../../services/config'
import { useTenantConfigs } from '../../../hooks/useTenantConfigs'
import { CountryId } from '../../../models/country-id'

const checkRenderShowCardLogPhone = (updatedAt) => {
  const country = localStorage.getItem('country')?.toLowerCase()
  const isBrazil = country === CountryId.BRAZIL.toLocaleLowerCase()

  return updatedAt && isBrazil
}

const mapPhonePriority = (phones) => {
  if (!phones || phones.length === 0) return []

  // Ordenar primeiro pelos campos de updatedAt (se existir)
  const sortedPhones = phones.sort((a, b) => {
    const dateA = new Date(a.updatedAt || 0).getTime()
    const dateB = new Date(b.updatedAt || 0).getTime()
    return dateB - dateA
  })

  // Priorizar os telefones do tipo WHATSAPP ou MOBILE
  const prioritizedPhones = sortedPhones.sort((a, b) => {
    const isAPriority = a.type === 'WHATSAPP' || a.type === 'MOBILE'
    const isBPriority = b.type === 'WHATSAPP' || b.type === 'MOBILE'

    if (isAPriority && !isBPriority) return -1
    if (!isAPriority && isBPriority) return 1
    return 0
  })

  // Retornar os dois primeiros telefones priorizados
  return prioritizedPhones.slice(0, 2)
}

const getCustomPhoneListItem = ({ personId = '', phones = [] }) => mapPhonePriority(phones).map((phone) => {
  const { number, type = 'contact', updatedAt = '' } = phone

  return (
    <CustomListItem
      showCardLog={checkRenderShowCardLogPhone(updatedAt)}
      key={type}
      fieldId={`${snakeToCamel(type)}Number`}
      fieldDefaultMessage="Contact Number"
      data={number}
      dataCardLog={{
        dataLog: phone,
        personId,
      }}
    />
  )
})

const ContactCard = ({ userData, personId }) => {
  const { configs } = useTenantConfigs()
  const globalExternalService = getGlobalAccountUrl()
  const [loggedPersonId, setLoggedPersonId] = useState(null)
  const fields = [
    {
      fieldId: 'email',
      fieldDefaultMessage: 'E-mail',
      dataIndex: 'email',
    },
  ]

  useEffect(() => {
    async function fetchLoggedPersonId() {
      const { personId: loggedId } = await getUserInfo()
      setLoggedPersonId(loggedId)
    }
    fetchLoggedPersonId()
  }, [])

  const handleEditButton = () => {
    const { tenantId, country, company } = configs

    const accessTokenNaturaWeb = `Bearer ${getCognitoAccessToken()}`

    const maintenanceParams = {
      personId,
      tenantId,
      countryId: country.alpha3Code,
      companyId: company.id,
      loggedPersonId,
      accessTokenNaturaWeb,
    }

    const token = crypto.AES.encrypt(JSON.stringify(maintenanceParams), process.env.REACT_APP_CONTACT_PASSPHRASE).toString()

    window.location.href = `${globalExternalService.url}/maintenance-contacts?token=${btoa(token)}`
  }

  const showEditButton = () => configs && configs.profile.shouldDisplayContactEditButton && process.env.REACT_APP_SHOW_EDIT_CONTACT_BUTTON === 'true'

  const checkRenderShowCardLogEmail = (email) => {
    if (!email) {
      return false
    }

    const { emailAddress = '', updatedAt = '' } = email
    const country = localStorage.getItem('country')?.toLowerCase()
    const isBrazil = country === CountryId.BRAZIL.toLocaleLowerCase()

    return emailAddress && updatedAt && isBrazil
  }

  const getData = (field, email) => {
    if (field.render) {
      return field.render()
    }

    const emailAddress = email && email.emailAddress && typeof email.emailAddress === 'string' ? email.emailAddress : ''
    return emailAddress
  }

  return (
    <Grid item xs={12} sm={6}>
      <CustomCard
        titleMessageId="personalContact"
        titleDefaultMessage="Personal Contact"
        showEditButton={showEditButton()}
        onEditButtonClick={handleEditButton}
      >
        <List dense>
          {getCustomPhoneListItem(userData)}
          {fields.map((field) => (
            <CustomListItem
              showCardLog={checkRenderShowCardLogEmail(userData[field.dataIndex])}
              key={field.fieldId}
              fieldId={field.fieldId}
              fieldDefaultMessage={field.fieldDefaultMessage}
              data={getData(field, userData[field.dataIndex])}
              dataCardLog={{
                dataLog: userData[field.dataIndex],
                personId: userData.personId,
              }}
            />
          ))}
        </List>
      </CustomCard>
    </Grid>
  )
}

export default ContactCard
